import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  icon: '🛒',
  number: '01',
  title: 'CHOOSE',
  description: 'Choose the concept, skill, project or classroom need you want to work on.'
}, {
  icon: '📥',
  number: '02',
  title: 'OPEN',
  description: 'Open the corresponding volume, activity, visual reference or teaching tool.'
}, {
  icon: '🎓',
  number: '03',
  title: 'TEACH',
  description: 'Print it, project it or use it alongside the way you already teach.'
}];
export function HowItWorks() {
  return <section className="w-full bg-navy px-5 py-12 sm:py-20" data-id="element-120" data-mp="cs80x1r1x5x8">
      <div className="mx-auto max-w-5xl" data-id="element-121" data-mp="crpz7plmdzhx">
        <div className="mx-auto max-w-2xl text-center" data-id="element-122" data-mp="gt1pzyg8cqrp">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-123" data-mp="grqjhqveh4ww">
            Choose. Open. Teach.
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-124" data-mp="19ae3f2ynudwe">
            Three simple steps between knowing what your students need and having a classroom-ready
            resource in front of you.
          </p>
        </div>
        <div className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-125" data-mp="2mnw56gnvewsm">
          {steps.map((step, index) => <React.Fragment key={step.number} data-id="element-126" data-mp="31csbo9aa41r4" data-mpi={index}>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.3,
            delay: index * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-127" data-mp="2wk8zngr8peof">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-gold/50 bg-navy-mid text-3xl" data-id="element-128" data-mp="3k88y72usm9dk">
                  {step.icon}
                </span>
                <span className="mt-4 font-display text-2xl font-bold text-gold" data-id="element-129" data-mp="1pwkhav503wqj">{step.number}</span>
                <h3 className="mt-2 text-lg font-bold text-white" data-id="element-130" data-mp="1kz25mwzln3eu">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/70" data-id="element-131" data-mp="3l11qez9bd2t5">
                  {step.description}
                </p>
              </motion.div>
              {index < steps.length - 1 && <div className="mx-auto h-8 w-px bg-gold/35 md:hidden" aria-hidden="true" data-id="element-132" data-mp="3tyu7a7uooiin" />}
            </React.Fragment>)}
        </div>
        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-133" data-mp="7tqj2p6ob74u">
          <p className="text-lg font-bold text-gold" data-id="element-134" data-mp="cs1tp24sllo4">You Keep Your Teaching Freedom.</p>
          <p className="mt-3 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-135" data-mp="cpp2dyd59yye">
            THE COMPLETE ART YEAR™ doesn&apos;t replace your teaching style. It gives you a strong,
            organized starting point so you don&apos;t have to build every resource yourself.
          </p>
        </div>
      </div>
    </section>;
}